const bTabs = {
    props: {
        activeTab:{
            type: String,
            default: ''
        },
        tabs: {
            type: Array,
            default(){
                return []
            }
        },
        customIcons: {
            default(){
                return []
            }
        }
    },
    data(){
        return {
            tab: null,
        }
    },
    template:
    `<div class="b-tabs">
        <ul class="b-tabs__nav">
            <li v-for="(tab, index) in tabs" :class="activeClass(tab.id)">
                <button type="button" class="b-tabs__lnk ui-tabs-anchor" @click="changeTab(tab.id)">
                    <template v-if="customIcons.length">
                        <i v-if="customIcons[index]" class="b-tabs__lnk__icon" v-html="customIcons[index]"></i>
                    </template>
                    <template v-else>
                        <i v-if="tab.icon" class="b-tabs__lnk__icon" v-html="tab.icon"></i>
                    </template>
                    <span class="b-tabs__lnk__txt">{{tab.label}} <i class="b-tabs__lnk__count" v-if="tab.count">{{tab.count}}</i></span>
                </button>
            </li>
        </ul>
    </div>`,
    mounted(){
        this.iniTabs();
        
    },
    methods:{
        iniTabs(){
            if(this.activeTab!==''){
                this.tab = this.activeTab            
            } else {
                if(this.tabs.length && this.tabs[0].id)
                    this.tab = this.tabs[0].id
            }
            this.$emit("onTabInit", this.tab)
        },
        changeTab(newTab){
            this.tab = newTab
            this.$emit("onTabChanged", this.tab)
        },
        activeClass(tab){
            if(this.tab === tab){
                return 'ui-tabs-active'
            }
            return ''
        }
    }
}